export default {
  get: "GET",
  post: "POST",
  delete: "DELETE",
  put: "PUT"
};
